<template>
  <div class="page-login">
    <div class="login-wrap">
      <div class="login-box">
        <div class="login-form">
          <div class="login-form__hd">
            <img src="@/assets/img/logo-black.png" alt="">
          </div>
          <div class="login-form__bd">
            <Form ref="loginValidate" :model="loginValidate" :rules="ruleValidate">
              <FormItem prop="account">
                <Input v-model="loginValidate.account" placeholder="请输入用户名" clearable :maxlength="20">
                  <Icon type="md-person" slot="prepend" />
                </Input>
              </FormItem>
              <FormItem prop="password">
                <Input type="password" v-model="loginValidate.password" password placeholder="请输入密码" :maxlength="20">
                  <Icon type="md-lock" slot="prepend" />
                </Input>
              </FormItem>
              <FormItem prop="captcha">
                <Row>
                  <Col span="14">
                    <Input v-model="loginValidate.captcha" placeholder="请输入验证码" :maxlength="4">
                      <Icon type="md-code-working" slot="prepend" />
                    </Input>
                  </Col>
                  <Col span="10">
                    <img class="captcha" ref="loginCaptcha" :src="captchaImg" alt="" @click.prevent="changeCaptcha()">
                  </Col>
                </Row>
              </FormItem>
              <FormItem>
                <Button type="primary" long size="large" class="login-btn" @click="handleLogin('loginValidate')" :loading="loading">
                  <span v-if="!loading">登 录</span>
                  <span v-else>登录中...</span>
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
      <div class="copyright">
        <p><span>&copy; 2020 亚信科技（中国）有限公司 版权所有</span></p>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '../utils/'
export default {
  data () {
    return {
      loading: false,
      loginValidate: {
        account: '',
        password: '',
        captcha: ''
      },
      ruleValidate: {
        account: [
          { required: true, whitespace: true, message: '请输入用户名', trigger: 'blur' },
          { type: 'string', min: 5, message: '用户名至少5个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, whitespace: true, message: '请输入密码', trigger: 'blur' },
          { type: 'string', min: 5, max: 20, message: '密码5-20个字符', trigger: 'blur' }
        ],
        captcha: [
          { required: true, trigger: 'blur', validator: utils.captchaValid }
        ]
      }
    }
  },
  computed: {
    captchaImg () {
      return this.$store.state.captcha
    }
  },
  methods: {
    changeCaptcha () {
      this.$store.dispatch('captcha')
    },
    handleLogin (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('login', {
            account: this.loginValidate.account,
            password: utils.md5(this.loginValidate.password),
            code: this.loginValidate.captcha,
            uuid: this.$store.state.captchaId
          }).catch((err) => {
            this.loading = false
            this.$Modal.error({
              title: '登录失败',
              content: err.message || '登录失败，请重试！'
            })
          })
        } else {
          this.$Message.error('请输入必填项！')
        }
      })
    },
    resetForm () {
      this.$refs['loginValidate'].resetFields()
      this.changeCaptcha()
    }
  },
  created () {
    const userInfo = this.$store.state.userInfo
    if (userInfo) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('captcha')
    }
  },
  mounted () {
    window.addEventListener('keydown', (e) => {
      if ((e.key && e.key === 'Enter') || (e.keyCode && e.keyCode === 13)) {
        this.handleLogin('loginValidate')
      }
    })
  }
}
</script>
<style lang="less">
  @import '../assets/less/base/variables.less';
  .page-login {
    background: #2f3337 url(../assets/img/login-bg.jpg) no-repeat;
    background-size: cover;
    text-align: center;
    padding: 30px 15px;
    min-height: 520px;
    height: 100%;
    .login-wrap {
      max-width: 320px;
      min-width: 290px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
    }
    .login-box {
      padding: 32px 24px 24px 24px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 4px;
      position: relative;
      transition: all @animation-time;
    }
    .copyright {
      margin-top: 15px;
      text-align: center;
      color: rgba(255,255,255,.7);
      font-size: 12px;
      a {
        color: rgba(255,255,255,.7);
        margin-right: 10px;
      }
      a, span {
        display: inline-block;
      }
    }
    .login-form {
      &__hd {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 24px;
        text-align: center;
        position: relative;
        img {
          display: inline-block;
          width: 80%;
        }
      }
      .ivu-form-item {
        margin-bottom: 24px;
      }
      .ivu-form-item-error-tip {
        padding-top: 4px;
      }
      .ivu-input-group-append, .ivu-input-group-prepend {
        padding: 4px 10px;
        font-size: 16px;
        color: #aaa;
        border-radius: 4px;
        background-color: #f9f9f9;
        .ivu-icon {
          min-width: 12px;
        }
      }
      .captcha {
        display: block;
        width: 100%;
        height: 32px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
</style>
